import {MoreOutlined} from "../../../__snowpack__/pkg/@ant-design/icons.js";
import {Button, Popover, Space} from "../../../__snowpack__/pkg/antd.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import React, {useMemo, useState} from "../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
import ActionButton from "./ActionButton.js";
import "./index.css";
import TableRowActionsContext from "./TableRowActionsContext.js";
export default function TableRowActions(props) {
  const {actions, buttonCount = 4, moreButtonType = "text-icon", children, emptyPlaceholder = "-", ...spaceProps} = props;
  const {formatMessage} = useIntl();
  const [moreButtonPopoverVisible, setMoreButtonPopoverVisible] = useState(false);
  const [keepMoreButtonPopoverOpen, setKeepMoreButtonPopoverOpen] = useState(false);
  let buttons = actions?.length ? actions.map((action) => /* @__PURE__ */ React.createElement(ActionButton, {
    ...action
  }, action.text)) : Array.isArray(children) ? children : [children];
  buttons = [...buttons].filter((button) => button && (button.props?.visible ?? true));
  const values = useMemo(() => ({
    keepMoreButtonPopoverOpen,
    setKeepMoreButtonPopoverOpen
  }), [keepMoreButtonPopoverOpen, setKeepMoreButtonPopoverOpen]);
  if (buttons?.length === 0) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, emptyPlaceholder);
  }
  return /* @__PURE__ */ React.createElement(TableRowActionsContext.Provider, {
    value: values
  }, /* @__PURE__ */ React.createElement(Space, {
    direction: "vertical",
    size: spaceProps.direction === "horizontal" ? 4 : 0,
    ...spaceProps,
    className: classNames("table-row-actions", spaceProps?.className)
  }, buttons?.slice(0, buttons.length > buttonCount ? buttonCount - 1 : void 0), buttons.length > buttonCount && /* @__PURE__ */ React.createElement(Popover, {
    placement: "leftBottom",
    overlayClassName: "table-row-actions-popover",
    visible: keepMoreButtonPopoverOpen || moreButtonPopoverVisible,
    onVisibleChange: (visible) => {
      setMoreButtonPopoverVisible(visible);
    },
    align: {targetOffset: [-8, -4]},
    content: /* @__PURE__ */ React.createElement(Space, {
      direction: "vertical",
      size: 0
    }, buttons?.slice(buttonCount - 1))
  }, /* @__PURE__ */ React.createElement(Button, {
    type: "link",
    size: "small"
  }, (moreButtonType === "text" || moreButtonType === "text-icon") && /* @__PURE__ */ React.createElement("span", null, formatMessage({id: "more"})), (moreButtonType === "icon" || moreButtonType === "text-icon") && /* @__PURE__ */ React.createElement(MoreOutlined, {
    rotate: 90,
    style: {marginLeft: 4}
  })))));
}
TableRowActions.Button = ActionButton;
